import gql from 'graphql-tag';


// XXX: For now only post directly to twitter..
// Later we need something like submit content
export const gqlTweetWithMedia = gql`
  mutation twitterPost($input: TwitterPostInput!) {
    twitterPost(input: $input) {
      tweetData {
        tweetId
        tweetUrl
      }

      errors { key, message }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/shared/gql/content.js